import { render, staticRenderFns } from "./DashboardStatusProductWidget.vue?vue&type=template&id=09e3acfc&scoped=true&"
import script from "./DashboardStatusProductWidget.vue?vue&type=script&lang=js&"
export * from "./DashboardStatusProductWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e3acfc",
  null
  
)

export default component.exports